/* tslint:disable */
/* eslint-disable */
/**
 * home-health-api
 * home-health-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface BasicInfo
 */
export interface BasicInfo {
    /**
     * 
     * @type {string}
     * @memberof BasicInfo
     */
    branch: string;
    /**
     * 
     * @type {string}
     * @memberof BasicInfo
     */
    team: string;
    /**
     * 
     * @type {string}
     * @memberof BasicInfo
     */
    last_name: string;
    /**
     * 
     * @type {string}
     * @memberof BasicInfo
     */
    first_name: string;
}

/**
 * Check if a given object implements the BasicInfo interface.
 */
export function instanceOfBasicInfo(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "branch" in value;
    isInstance = isInstance && "team" in value;
    isInstance = isInstance && "last_name" in value;
    isInstance = isInstance && "first_name" in value;

    return isInstance;
}

export function BasicInfoFromJSON(json: any): BasicInfo {
    return BasicInfoFromJSONTyped(json, false);
}

export function BasicInfoFromJSONTyped(json: any, ignoreDiscriminator: boolean): BasicInfo {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'branch': json['branch'],
        'team': json['team'],
        'last_name': json['last_name'],
        'first_name': json['first_name'],
    };
}

export function BasicInfoToJSON(value?: BasicInfo | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'branch': value.branch,
        'team': value.team,
        'last_name': value.last_name,
        'first_name': value.first_name,
    };
}

